/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentityProviderSettingsListQuery
 */
export interface IdentityProviderSettingsListQuery {
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsListQuery
     */
    showDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsListQuery
     */
    showDeleted?: boolean;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof IdentityProviderSettingsListQuery
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {number}
     * @memberof IdentityProviderSettingsListQuery
     */
    distributionChannel?: number | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsListQuery
     */
    agency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsListQuery
     */
    provider?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsListQuery
     */
    carrier?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityProviderSettingsListQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityProviderSettingsListQuery
     */
    limit?: number | null;
}

export function IdentityProviderSettingsListQueryFromJSON(json: any): IdentityProviderSettingsListQuery {
    return IdentityProviderSettingsListQueryFromJSONTyped(json, false);
}

export function IdentityProviderSettingsListQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityProviderSettingsListQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'showDisabled': !exists(json, 'showDisabled') ? undefined : json['showDisabled'],
        'showDeleted': !exists(json, 'showDeleted') ? undefined : json['showDeleted'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'distributionChannel': !exists(json, 'distributionChannel') ? undefined : json['distributionChannel'],
        'agency': !exists(json, 'agency') ? undefined : json['agency'],
        'provider': !exists(json, 'provider') ? undefined : json['provider'],
        'carrier': !exists(json, 'carrier') ? undefined : json['carrier'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function IdentityProviderSettingsListQueryToJSON(value?: IdentityProviderSettingsListQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'showDisabled': value.showDisabled,
        'showDeleted': value.showDeleted,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'distributionChannel': value.distributionChannel,
        'agency': value.agency,
        'provider': value.provider,
        'carrier': value.carrier,
        'offset': value.offset,
        'limit': value.limit,
    };
}


